import { ChatMessageAttachment } from 'features/chat/components/ChatAttachment/ChatMessageAttachment';
import { UnuploadedAttachment } from 'features/chat/config/types/Attachment';
import { useAttachmentsUpload } from 'features/chat/hooks/useAttachmentsUpload';

import { isMediaFile } from 'shared/utils/mediaFile';

type ChatMessageUnuploadedAttachmentsProps = {
  attachments: UnuploadedAttachment[];
};

export const ChatMessageUnuploadedAttachments = ({
  attachments,
}: ChatMessageUnuploadedAttachmentsProps) => {
  useAttachmentsUpload(attachments);

  const onlyMedia = attachments.every((attachment: UnuploadedAttachment) =>
    isMediaFile(attachment.contentType)
  );

  return (
    <ChatMessageAttachment attachments={attachments} onlyMedia={onlyMedia} />
  );
};
